<mat-horizontal-stepper *ngIf="redirect =='new'" linear="true" #stepper>
  <!-- Step 1 select equipmet -->
  <mat-step [stepControl]="formStepeOne">

    <form [formGroup]="formStepeOne">
      <ng-template class="font" matStepLabel>{{isChecked?'Selección de equipo':'Seleccione tipo de equipo'}}</ng-template>
      <div class="w-100 d-flex flex-column align-items-center">

        <mat-slide-toggle (change)="changeToggle($event)">{{!isChecked?'Equipos':'Tipo de equipos'}}</mat-slide-toggle>

        <!-- Select equipment -->
        <div *ngIf="!isChecked" class="w-100 d-flex flex-row align-items-center">
          <div style="width:50%;">
            <data-table title='' [columns]='columnasEquipos' [configuration]='configurationEquipos'
              [reloadTable]='recargarTablaEquipos' (clickRow)='clickRowEquipment($event)' [params]='[]'
              [url]='urlTableEquipments'>
            </data-table>
          </div>

          <div *ngIf="equipment" style="width:50%; text-align: center">
            <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
            <h2 style="margin-top: 5px;">serial: {{equipment.serial}}</h2>
          </div>

        </div>


        <!-- Select equipment type -->
        <div style="width: 100%; display: flex; flex-direction: column; align-items: center;" *ngIf="isChecked">

          <app-button-label class="mt-3" [labels]="[equipmentType?.name]"> </app-button-label>

          <div style="width: 100%;">
            <data-table title='' [columns]='columnasTipoEquipo' [configuration]='configurationTipoEquipo'
              [reloadTable]='recargarTablaTipoEquipo' (clickRow)='clickRowEquipmentType($event)' [params]='[]'
              [url]='urlTableEquipmentType'>
            </data-table>
          </div>

        </div>

        <button matStepperNext *ngIf="equipmentType || equipment" style="width: 70%; margin-top: 15px;" color="primary"
          class="button-save mat-elevation-z5 " mat-raised-button>Continuar</button>

        <div style="display: none">
          <mat-form-field>
            <input autocomplete="off" type="text" formControlName='id' matInput required>
          </mat-form-field>
        </div>
      </div>
    </form>

  </mat-step>

  <!-- Step 2 form -->
  <mat-step [stepControl]="formRegistry">
    <ng-template class="font" matStepLabel>Formulario</ng-template>
    <ng-container *ngTemplateOutlet="formActivity"></ng-container>
  </mat-step>

  <!-- Step 3 resources -->
  <mat-step *ngIf="inventoryModule">
    <ng-template class="font" matStepLabel>Recursos</ng-template>

    <app-handler-items (listItemComplete)="createActivityWithResources($event)"
      (comboItemLength)="comboItemsLength($event)" [titleDialog]="'Recursos'" [headerDetails]="false"
      [acceptButton]="true" [labelAcceptButton]="!this.isChecked?'Guardar':'Continuar'" [initializeEmptyItem]="true" [urlItemCombo]="urlGetItems">
    </app-handler-items>

  </mat-step>

  <mat-step *ngIf="equipmentType">
    <ng-template class="font" matStepLabel>Formulario equipos</ng-template>

    <form (ngSubmit)="createActivityBulk()">

      <div *ngFor="let item of equipmentsByEquipmentType; let i = index">
        <div class="first-row">
          <div class="row-item">
            <mat-form-field>
              <mat-label>código</mat-label>
              <input readonly matInput placeholder="código" [value]="item.code">
            </mat-form-field>
          </div>
          <div class="row-item">
            <mat-form-field>
              <mat-label>Odometro actual</mat-label>
              <input type="number" readonly matInput placeholder="Odometro" [value]="item.currentOdometer">
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <mat-label>{{item.components?.length > 0 ? 'Componentes' : 'No tiene Componentes'}}</mat-label>
              <mat-select [(ngModel)]="activityFromByEquipmetType[i].componentId" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let item of item.components" value={{item.id}}>
                  {{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row-item">
            <mat-form-field>
              <mat-label>Odometro ultimo mtto</mat-label>
              <input type="number" matInput placeholder="Odometro ultimo mtto"
                [(ngModel)]="activityFromByEquipmetType[i].odometerLastMtto" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </div>

          <div class='row-item'>
            <mat-form-field>
              <mat-label>Fecha proximo Mtto</mat-label>
              <input required matInput [matDatepicker]="pickerInicio" autocomplete="off" matInput
                [(ngModel)]="activityFromByEquipmetType[i].lastMttoDate" [ngModelOptions]="{standalone: true}">
              <mat-datepicker-toggle matSuffix [for]="pickerInicio">
              </mat-datepicker-toggle>
              <mat-datepicker #pickerInicio [touchUi]='movil?true:false'></mat-datepicker>
            </mat-form-field>
          </div>
        </div>



      </div>
      <div style="width: 100%;  margin:50px 0 30px 0; display:flex; justify-content: center;">
        <button style="width: 70%;" color="primary" class="button-save mat-elevation-z5 " mat-raised-button
          type="submit">Guardar</button>
      </div>

    </form>

  </mat-step>


</mat-horizontal-stepper>

<mat-tab-group *ngIf="redirect == 'edit'" class="m-5">
  <mat-tab label="Formulario">
    <ng-container *ngTemplateOutlet="formActivity"></ng-container>
  </mat-tab>

  <!-- mat 3 Resources-->
<mat-tab *ngIf="inventoryModule"
label="Recursos">
<div class="mt-5">
  <data-table *ngIf="redirect =='edit'" label="Recursos"
    [title]='"Recursos Actividad"'
    [columns]='columnsResouces'
    [configuration]='configurationResouces'
    [reloadTable]='reloadResouces'
    [url]='urlGetTableResourcesActivity'
    [params]='paramsResources'
    (delete)='deleteResources($event)'
    (add)='addResources($event)'
    (edit)='editResources($event)'
    (internalData)="dataResources($event)">
  </data-table>
</div>


</mat-tab>

</mat-tab-group>

<ng-template #formActivity>
  <form [formGroup]="formRegistry" (ngSubmit)="formRegistry.valid?saveForm(formRegistry.value):errorForm()">

    <div class="d-flex w-100 mt-4">
      <div [style.flex]="redirect == 'edit'? 10 : 12 ">

        <div class="first-row">
          <div class="row-item">
            <mat-form-field>
              <mat-label>Código</mat-label>
              <input readonly matInput placeholder="Código" [value]="equipment?.code??equipmentType?.name">
            </mat-form-field>
          </div>

          <div class="row-item" *ngIf="equipment">
            <mat-form-field>
              <mat-label>Odometro actual</mat-label>
              <input type="number" readonly matInput placeholder="Odometro actual" [value]="equipment?.currentOdometer">
            </mat-form-field>
          </div>

          <div class="row-item" *ngIf="equipment">
            <mat-form-field>
              <mat-label>Componentes</mat-label>
              <mat-select formControlName="componentId">
                <mat-option *ngFor="let item of equipment?.components" [value]="item.id">
                  {{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>



          <div class='row-item' *ngIf="equipment">
            <mat-form-field>
              <mat-label>Fecha proximo Mtto</mat-label>
              <input [required]="formStepeOne.controls.id.value" matInput [matDatepicker]="pickerInicio" autocomplete="off" matInput
                formControlName='lastMttoDate' >
              <mat-datepicker-toggle matSuffix [for]="pickerInicio">
              </mat-datepicker-toggle>
              <mat-datepicker #pickerInicio [touchUi]='movil?true:false'></mat-datepicker>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

        </div>

        <div class="default-row">

          <div class="row-item" *ngIf="equipment">
            <mat-form-field>
              <input type="number" formControlName='odometerLastMtto' matInput placeholder="Odometro ultimo Mtto"
                #ultimoMtto oninput="this.value = this.value.slice(0,10)"
                [required]="formStepeOne.controls.id.value && equipment.currentOdometer > 0">
              <mat-hint>{{ultimoMtto.value.length}}/10</mat-hint>
              <mat-error *ngIf="equipment.currentOdometer > 0">Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <input type="number" required formControlName='odometerFrequency' matInput
                placeholder="Frecuencia Odometro" #frecuenciaOdometro oninput="this.value = this.value.slice(0,10)">
              <mat-hint>{{frecuenciaOdometro.value.length}}/10</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <input type="number" required formControlName='timeFrequency' matInput
                placeholder="Frecuencia Tiempo (dias)" #frecuenciaTiempo oninput="this.value = this.value.slice(0,10)">
              <mat-hint>{{frecuenciaTiempo.value.length}}/10</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <div class="row-item">
            <mat-form-field>
              <input required type="number" formControlName='cost' matInput placeholder="Costo" #costo
                oninput="this.value = this.value.slice(0,10)">
              <mat-hint>{{costo.value.length}}/10</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

        </div>

        <div class="default-row" *ngIf="!inventoryModule">

          <div class="row-item">
            <mat-form-field>
              <input autocomplete="off" type="text" formControlName='resources' matInput placeholder="Recursos" #recurso
                maxlength="255">
              <mat-hint>{{recurso.value.length}}/255</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="default-row">

          <div class='row-item'>

            <mat-form-field>
              <textarea
              autocomplete="off"
              formControlName="description"
              matInput
              #descripcion
              rows="3"
              maxlength="10000"
              placeholder="Procedimiento"
              class="min-rows-2 resizable-textarea"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="15"
              ></textarea>
              <mat-hint>{{ descripcion.value.length }}/10000</mat-hint>
            </mat-form-field>

          </div>
        </div>

      </div>

      <div style='flex:.2' *ngIf="redirect == 'edit'">
        <button mat-mini-fab color="warn" type="submit">
          <mat-icon>save</mat-icon>
        </button>

        <button mat-mini-fab color="accent" (click)='deleteActivity($event)' style='margin-top: 10px;'>
          <mat-icon>delete</mat-icon>
        </button>

        <button mat-mini-fab color="primary" (click)='back($event)' style='margin-top: 10px;'>
          <mat-icon>reply</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="redirect == 'new'" style="width: 100%;  margin-top: 50px; display:flex; justify-content: center;">
      <button style="width: 70%;" color="primary" class="button-save mat-elevation-z5 " mat-raised-button
        type="submit">{{!isChecked && !inventoryModule?'Guardar':'Continuar'}}</button>
    </div>

  </form>
</ng-template>
